import React, { Component } from 'react';
import styled from 'styled-components';
import { Tap } from '../dooh-react-utils';
import preloader from '../preload';
import ctaVideo from '../assets/bubble.webm';
import header from '../assets/header.png';
import start from '../assets/start.png';
import cta from '../assets/cta.png';

const Wrap = styled(Tap)`
  background-color: #ffdc46;

  #bubble, #overlay {
    position: absolute;
    top: 0;
    left: 0;
  }

  #overlay {
    background: url('${preloader.get(header)}') no-repeat 50% 50px;
  }

  #button {
    position: absolute;
    top: 1100px;
    left: ${(1080 - 420) / 2}px;

    animation-name: pulse_animation;
    animation-duration: 1.3s;
    animation-timing-function: ease-in-out;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-play-state: running;
  }

  @keyframes pulse_animation {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(.9);
    }

    100% {
      transform: scale(1);
    }
  }
`;

class Screen extends Component {
  render() {
    return (
      <Wrap onTap={this.props.gotoNextScreen}>
        <video id="vid" src={preloader.get(ctaVideo)} muted autoPlay loop />
        <img id="overlay" src={preloader.get(cta)} alt="" />
        <img id="button" src={preloader.get(start)} alt="" />
      </Wrap>
    );
  }
}

export default Screen;
